import { render } from "./lotteryRecord.vue?vue&type=template&id=370cfa9e&scoped=true"
import script from "./lotteryRecord.vue?vue&type=script&lang=js"
export * from "./lotteryRecord.vue?vue&type=script&lang=js"

import "./lotteryRecord.vue?vue&type=style&index=0&id=370cfa9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370cfa9e"]])

export default __exports__